import styled from 'styled-components';

export const OptionBox = styled.div`
display: flex;
flex-direction: column;
gap: 8px;
margin: 1rem 0;
padding: 16px 8px;
border-radius: 8px 0px 0px 0px;
border: 1px solid #E5E7EB;
background-color: var(--background-info);
opacity: 0px;
`;

export const OptionBoxText = styled.div<{ $fontWeight?: string }>`
font-size: var(--typography-body2-size);
line-height: 24px;
font-weight: ${props => props.$fontWeight};
`;

export const OptionSelection = styled.div`
display: flex;
gap: 8px;
`;